import { render, staticRenderFns } from "./BodyStageForm.vue?vue&type=template&id=3823f32a&scoped=true&"
import script from "./BodyStageForm.vue?vue&type=script&lang=js&"
export * from "./BodyStageForm.vue?vue&type=script&lang=js&"
import style0 from "./BodyStageForm.vue?vue&type=style&index=0&id=3823f32a&lang=scss&scoped=true&"
import style1 from "./BodyStageForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3823f32a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
